<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">
        Plano de Governo
        <select class="select-periodo" v-model="periodoSelecionado">
          <option v-for="(periodo, index) in periodos" :key="index" :value="periodo">{{ periodo }}</option>
        </select>
      </h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list ref="vuetable" 
            :show-empty="true" 
            title="Lista dos Compromissos" 
            api-url="planogoverno/compromisso"
            report-title="Planos de Governo" 
            :fields="fields" 
            :initial-page="pagina" 
            :pageCollection="'planoGoverno'"
            :append-params="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-2">
                  <label class="custom-font" for="unidade_filter">Unidades</label>
                  <div class="custom-select">
                    <select 
                      v-model="unidade_executora" 
                      @change="consultar" 
                      ref="unidade_filter" 
                      name="unidade_filter"
                      class="form-control select-selected"
                    >
                      <optgroup label="Secretarias">
                        <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                          {{ s.sigla }}
                        </option>
                      </optgroup>

                      <optgroup label="Autarquias">
                        <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                          {{ a.sigla }}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="col-sm-8">
                  <label class="custom-font" for="titulo_filter">Título</label>
                  <input type="text" v-model="titulo" class="form-control" name="titulo_filter" />
                </div>
                <div class="col-sm-2">
                  <label class="custom-font" for="status_filter">Status</label>
                  <div class="custom-select">
                    <select 
                      v-model="status" 
                      @change="consultar" 
                      ref="status_filter" 
                      name="status_filter"
                      class="form-control select-selected"
                    >
                      <option value='' selected>
                        Todos
                      </option>
                      <option v-for="status in listas.status" :key="status" :value="status">
                        {{ status }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12">
                  <button @click="consultar()" class="btn btn-default margem-topo" name="btnFiltrar">
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button @click="limpar()" class="btn btn-default margem-topo" name="btnLimpar">
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link class="btn btn-default" :to="{ name: 'admin_planogoverno_save' }">
                <i class="fa fa-plus" aria-hidden="true"></i> Adicionar
              </router-link>
              <button class="btn btn-default" data-toggle="collapse" data-target="#filtros">
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <router-link 
                  title="Ver Detalhes" 
                  class="btn btn-primary" 
                  :to="{ name: 'admin_planogoverno_details', 
                  params: { id: props.rowData.id } }">
                  <font-awesome-icon :icon="'search'"></font-awesome-icon>
                </router-link>
                <router-link 
                  title="Editar" 
                  class="btn btn-primary" 
                  :to="{ name: 'admin_planogoverno_edit', params: { id: props.rowData.id } }">
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </router-link>
                <button title="Homologar" type="button" class="btn btn-primary" @click="editar(props.rowData)">
                  <font-awesome-icon :icon="'check'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 15px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.select-periodo {
  border: 1px solid transparent;
  color: #468c36;
  background-color: transparent;
  transition: color 0.3s ease, border-color 0.3s ease;
}

.select-periodo:focus {
  border-color: transparent;
  box-shadow: none;
  outline: none;
}

.select-periodo:hover {
  color: #a1be4d;
  cursor: pointer;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'planos-governo',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'unidade_executora',
          title: 'Unidade Executora',
          sortField: 'unidade_executora',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'descritivo',
          title: 'Título',
          sortField: 'titulo',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'data_conclusao',
          title: 'Homologado',
          sortField: 'data_conclusao',
          titleClass: 'text-center',
          dataClass: 'text-center',
          filterable: true,
          callback(value) {
            return value === null ? 'Não' : 'Sim'
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }],
      listas: {
        secretarias: [],
        autarquias: [],
        status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado']
      },
      periodos: [
        '2017-2020',
        '2021-2024',
        '2025-2028',
      ],
      periodoSelecionado: '2025-2028',
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    if (this.$router.history.current.params.state) {
      this.state = this.$router.history.current.params.state
    }

    this.loadUnidades()
  },
  computed: {
    filtros() {
      const { descricao, unidade_executora, status } = this
      return {
        descricao,
        unidade_executora,
        status
      }
    },
    pagina: {
      get() {
        const { planoGoverno } = this.$store.state.vuetableState
        const { pagina } = planoGoverno
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'planoGoverno',
          value: value
        })
      }
    },

    unidade_executora: {
      get() {
        const { planoGoverno } = this.$store.state.vuetableState
        const { unidade_executora } = planoGoverno.filtros

        return unidade_executora
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'unidade_executora',
          collection: 'planoGoverno',
          value: value
        })
        this.resetPageStore()
      }
    },
    descricao: {
      get() {
        const { planoGoverno } = this.$store.state.vuetableState
        const { descricao } = planoGoverno.filtros
        return descricao
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'planoGoverno',
          value: value
        })
        this.resetPageStore()
      }
    },
    status: {
      get() {
        const { planoGoverno } = this.$store.state.vuetableState
        const { status } = planoGoverno.filtros
        return status
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'planoGoverno',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    async loadUnidades() {
      const { data: { data: secretarias } } = await request.get('listar-secretarias')
      const { data: { data: autarquias } } = await request.get('listar-autarquias')

      this.listas.secretarias = secretarias
      this.listas.autarquias = autarquias
    },
    adicionarAcao(rowData) {
      this.$router.push({
        name: 'user_planogoverno_acao_save',
        params: { rowData }
      })
    },
    editar(modelData) {
      this.$router.push({
        name: 'admin_planogoverno_save',
        params: { modelData }
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = 'PLANOGOVERNO'

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.delete(
            data,
            () => {
              dt.refresh()
            },
            () => {
              console.log(
                'houve um error ao tentar excluir este item, por favor tente novamente mais tarde!'
              )
            }
          )
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este Plano de Governo?',
        config
      )
    },
    consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.unidade_executora = ''
      this.descricao = ''
      this.status = ''

      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'planoGoverno',
        value: 1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/index.vue